module.exports = __webpack_public_path__ + "static/img/home_dibu_icon_wxhd@2x.44e0db6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeImg/home_dibu_icon_wxhd@2x.png
// module id = ifXQ
// module chunks = 0